var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconCreditCard = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.8236 9H12.4894C11.6623 9 10.9893 9.71491 10.9893 10.5934V16.967C10.9893 17.8455 11.6623 18.5604 12.4894 18.5604H22.8236C23.6507 18.5604 24.3238 17.8455 24.3238 16.967V10.5934C24.3238 9.71491 23.6507 9 22.8236 9ZM14.4897 12.1868H13.4895C13.2135 12.1868 12.9895 11.9489 12.9895 11.6557C12.9895 11.3625 13.2135 11.1245 13.4895 11.1245H14.4897C14.7657 11.1245 14.9897 11.3625 14.9897 11.6557C14.9897 11.9489 14.7657 12.1868 14.4897 12.1868ZM17.656 15.9047C16.5529 15.9047 15.6558 14.9519 15.6558 13.7802C15.6558 12.6085 16.5529 11.6557 17.656 11.6557C18.7591 11.6557 19.6562 12.6085 19.6562 13.7802C19.6562 14.9519 18.7591 15.9047 17.656 15.9047ZM21.8235 16.4359H20.8234C20.5473 16.4359 20.3233 16.1979 20.3233 15.9047C20.3233 15.6116 20.5473 15.3736 20.8234 15.3736H21.8235C22.0995 15.3736 22.3235 15.6116 22.3235 15.9047C22.3235 16.1979 22.0995 16.4359 21.8235 16.4359Z",
    fill: "#DAF8FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.8237 19.6205H11.4895C10.6624 19.6205 9.98937 18.9056 9.98937 18.0271V11.8203L8.37219 18.2258C8.16417 19.0692 8.63822 19.9445 9.43331 20.1772L19.7435 23.1101C19.8715 23.1462 19.9995 23.1621 20.1255 23.1621C20.7896 23.1621 21.3977 22.6916 21.5727 21.983L22.1868 19.5685C22.0697 19.5993 21.9497 19.6205 21.8237 19.6205Z",
    fill: "#DAF8FF",
    fillOpacity: 0.5
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconCreditCard);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon_credit_card.9e51285b083c1359777fed0eae85e75c.svg";